// Extracted from Dashboard/index.web.jsx on 2026-10-02.
import TotalAlertCard from '../TotalAlertCard/TotalAlertCard';
import type { DashboardSummaryProps } from '../../types/dashboard.types';

const DashboardSummary = ({
  weatherAlertCount,
  fusionAlertCount,
  totalAlarmsCount,
  canViewAlarms,
}: DashboardSummaryProps) => (
  <div className="row w-100 mt-0 g-3">
    <div className="col-12 col-xl-3">
      <TotalAlertCard alertCount={weatherAlertCount} title="Weather Alerts" />
    </div>
    <div className="col-12 col-xl-3">
      <TotalAlertCard alertCount={fusionAlertCount} title="Fusion Alerts" />
    </div>
    <div className="col-12 col-xl-3">
      <TotalAlertCard alertCount={'Coming Soon'} title="AI Alerts" />
    </div>
    <div className="col-12 col-xl-3">
      <TotalAlertCard
        alertCount={totalAlarmsCount}
        title="Pending Alarms"
        navLink={canViewAlarms ? '/overwatch/pendingalarms' : ''}
      />
    </div>
  </div>
);

export default DashboardSummary;
